module.exports = {
	getAPI: function () {
		// return 'https://api.fortuneonline.in/api';
		// return 'http://fortuneuatapi.infoware.xyz/api';
		return 'https://api.fortunebusiness.in/api';
	},
};
